// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__15SEf","upload":"Small_upload__3xK2f","imageWrap":"Small_imageWrap__3JFXw","removeBtn":"Small_removeBtn__zt3FS"};